<template>

  <!-- Chef About Block -->
  <page-block
    no-body
    v-if="hasContent"
    class="chef-about-block"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign">

    <titled-text-element
      :value="value"/>

    <!--
    <div
      class="chef-about-block__header">

      <img
        src="/images/icons/left-up-element-chef-cv.svg"/>

      <img
        class="xs-hide sm-hide"
        src="/images/icons/righ-up-element.svg">

    </div>
    -->

    <chef-about-element
      :odd="index % 2"
      :value="element"
      :key="element.id"
      v-for="(element, index) in value.elements"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import ChefAboutElement from '@src/components/element/chef-about-element';
  import TitledTextElement from '@src/components/element/titled-text-element';

  export default {
    name: 'chef-about-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      ChefAboutElement,
      TitledTextElement,
    },
  };

</script>

<style lang="scss">

  .chef-about-block {
    color: inherit;

    &__header {
      display: flex;
      justify-content: space-between;

      img {
        max-height: 160px;
      }
    }
  }

</style>
